import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import SVG from 'react-inlinesvg'
import arrowLeft from '../../../_metronic/assets/custom-icons/arrowLeft.svg'
import arrowRight from '../../../_metronic/assets/custom-icons/arrowRight.svg'
import useUtils from './useUtils'
function Tab2({values, setFieldValue, errors, touched}) {
  const {fetchModules} = useUtils()
  const modules = useSelector(state => state.module?.records || []);

  const onSelection = (module) => {
    if (!values.modules.includes(module.title)) {
      setFieldValue('modules', [...values.modules, module.title]); 
      setFieldValue('moduleIds', [...values.moduleIds, module.id]); 
    }
  };

  const onRemoveOne = (moduleTitle) => {
    const moduleIndex = values.modules.indexOf(moduleTitle); 
    if (moduleIndex > -1) {
      const updatedModule = values.modules.filter((value) => value !== moduleTitle);
      setFieldValue('modules', updatedModule);
      const updatedModuleIds = values.moduleIds.filter((_, index) => index !== moduleIndex);
      setFieldValue('moduleIds', updatedModuleIds);
    }
  };


  const onRemoveAll = () => {
    setFieldValue('modules', []); 
    setFieldValue('moduleIds', []); 
  };


  const onSelectAll = () => {
    const allmoduleTitles = modules.map(module => module.title); 
    const allmoduleIds = modules.map(module => module.id); 
    setFieldValue('modules', allmoduleTitles);
    setFieldValue('moduleIds', allmoduleIds);
  };

  useEffect(() => {
    fetchModules(values.languageId)
  }, [values.languageId])


  return (
    <div>
      <div className="d-flex align-items-start justify-content-center gap-10 flex-wrap">
        <div className='d-flex flex-column gap-5 text-gray-800 fw-bold fs-6'>
          All Modules
          <div className="pb-4 shadow-lg rounded-3 overflow-hidden" style={{ width: '340px', minHeight: '250px' }}>
            <div className=" d-flex justify-content-center align-items-center" style={{background:"#f5f8fa", height: '35px' }}>
              <div  style={{cursor:'pointer'}} onClick={onSelectAll}> <span className={`svg-icon svg-icon-1 svg-icon-primary`}>
                  <SVG src={arrowRight} className='svg-icon-2 svg-icon-primary' />
                </span></div>
            </div>
            <div className="p-2 pt-7 c-black t-14 d-flex flex-column">            
                <div style={{height: '400px', overflowY: 'auto'}}>
                {modules.map((module, index) => (
                  <div key={index} className="d-flex gap-2">
                   <div style={{background:"#eff2f5"}} className='mb-5 rounded-circle border border-4 border-white h-20px w-20px'></div>
                    <div style={{cursor:'pointer'}} className='text-gray-800  fw-bold fs-6' onClick={() => onSelection(module)}>{module.title}</div>
                  </div>
                ))}
                </div>
            </div>
          </div>
        </div>

        <div  className='d-flex gap-5 flex-column text-gray-800 fw-bold fs-6'>
          Selected Modules
          <div className="pb-4 shadow-lg rounded-3 overflow-hidden" style={{ width: '340px', minHeight: '250px' }}>
            <div className=" d-flex justify-content-center align-items-center"  style={{background:"#f5f8fa", height: '35px' }}>
            
            <div style={{cursor:'pointer'}} onClick={onRemoveAll}> <span className={`svg-icon svg-icon-1 svg-icon-primary`}>
                  <SVG src={arrowLeft} className='svg-icon-2 svg-icon-primary' />
                </span></div>
            </div>
            <div className="p-2 pt-7 c-black t-14 d-flex flex-column ">
            <div style={{height: '400px', overflowY: 'auto'}}>
                {values.modules && values.modules.map((moduleTitle, index) => (
                  <div key={index} className="d-flex gap-2">
                  <div style={{background:"#eff2f5"}} className='mb-5 rounded-circle border border-4 border-white h-20px w-20px'></div>
                    <div className='text-gray-800  fw-bold fs-6' style={{cursor:'pointer'}} onClick={() => onRemoveOne(moduleTitle)}>{moduleTitle}</div>
                 </div>
                ))}
              </div>
            </div>
          </div>
          {touched.moduleIds && errors.moduleIds && (
            <div className='fv-plugins-message-container ms-3'>
              <span role='alert' className='text-danger'>
                {errors.moduleIds}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Tab2
